import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2521886")

_pushScopeId("data-v-e2521886")
const _hoisted_1 = { class: "p-field p-m-4" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { id: "name-help" }
const _hoisted_5 = { id: "name-help" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.kpiSchedulerTabViewDescriptor.dialog.style,
    contentStyle: _ctx.kpiSchedulerTabViewDescriptor.dialog.contentStyle,
    header: _ctx.$t('kpi.kpiScheduler.saveScheduler'),
    visible: true,
    modal: true,
    class: "full-screen-dialog p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('save', _ctx.name))),
        disabled: _ctx.saveSchedulerButtonDisabled
      }, null, 8, ["label", "disabled"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InputText, {
            class: ["kn-material-input", {
                        'p-invalid': _ctx.name && _ctx.name.length == 0 && _ctx.nameDirty
                    }],
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
            modelModifiers: { trim: true },
            max: "40",
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nameDirty = true))
          }, null, 8, ["modelValue", "class"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.name')) + " *", 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("small", _hoisted_5, _toDisplayString(_ctx.nameHelp), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "contentStyle", "header"]))
})